/**
 * JSON for embedding inside an inline `<script>`. The old
 * `.replace(/<\/script>/g, "</scr/ipt>")` was case-sensitive (`</SCRIPT>`
 * still ended the element) and changed the text readers saw. `\u003c` decodes
 * back to `<` inside a JS string, so the embedded story is unchanged.
 * Same helper as dotell-backend `utils/index.js#toInlineScriptJson`.
 */
export const toInlineScriptJson = (value: unknown): string =>
  JSON.stringify(value)
    .replace(/</g, "\\u003c")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
